import { Link } from 'react-router-dom';
import './MobileMenuButton.scss';

const MobileMenuButton = ({ label, path, toggleMenu }) => 
	<Link to={ path } className='mobileMenuButton' onClick={toggleMenu}>
		{ label }
	</Link>;

export default MobileMenuButton;